import { TableRow, TableCell } from "@/components/atoms/Table";
import { Progress } from "@/components/atoms/Progress";
import { TableTotalRowProps } from "./Dashboardtable.types";

export const TableTotalRow = ({ instrumentsTypes, groupedFlows, orderedMonthKeys, totalYear, totalColumns }: TableTotalRowProps) => (
    !!totalYear
        ? (<TableRow className="bg-gray-100 dark:bg-gray-800 font-bold">
            <TableCell colSpan={2}>Total</TableCell>
            {instrumentsTypes?.map((it) => {
                const total = orderedMonthKeys.reduce((acc, key) => acc + (groupedFlows[key][it.id] || 0), 0);
                return (
                    <TableCell key={it.id} className="gap-1">
                        {total > 0 && (
                            <>
                                <span>{total.toLocaleString("es-CO", { style: "currency", currency: "COP" })}</span>
                                <Progress variant="warning" showLabel value={(total * 100) / (totalYear || 1)} height="1.2rem" />
                            </>
                        )}
                    </TableCell>
                );
            })}
            <TableCell>
                <span>
                    {totalYear.toLocaleString("es-CO", { style: "currency", currency: "COP" })}
                </span>
                <Progress variant="success" showLabel value={100} height="1.2rem" />
            </TableCell>
            <TableCell></TableCell>
        </TableRow>)
        : (<TableRow>
            <TableCell colSpan={totalColumns} className="text-center py-4 text-gray-500">
                Sin datos
            </TableCell>
        </TableRow>)
);
